/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019杭州吉簿云数字科技有限公司 All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 字典</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月02日</li>
 * <li>@author     : ____′↘林永雄</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import {heyuiConfig} from "heyui.ext";

heyuiConfig.initDict({
  accountingStandards: {
    SMALL_BUSINESS: '小企业会计准则',
    BUSINESS: '企业会计准则',
    BUSINESS20191: '企业会计准则(2019年未执行新金融准则、新收入准则和新租凭准则)',
    BUSINESS20192: '企业会计准则(2019年已执行新金融准则、新收入准则和新租赁准则)',
    NONGOVERNMENTAL: '民间非营利组织会计制度',
    FARMER: '农民专业合作社财务会计制度'
  },
  accountingStandardsPrint: {'SMALL_BUSINESS': "小企", 'BUSINESS': "企业"},
  reportPrint: {'zcfz': "01表", 'lr': "02表", 'xjll': "03表"},
  defaultRadios: [{key: true, title: '是'}, {key: false, title: '否'}],
  statusRadios: [{key: true, title: '正常'}, {key: false, title: '不可用'}],
  enableRadios: [{key: true, title: '启用'}, {key: false, title: '不启用'}],
  needRadios: [{key: true, title: '需要'}, {key: false, title: '不需要'}],
  reportTemplateType: {0: "普通报表", 1: "资产报表"},
  reportTemplateItemType: {0: "资产", 1: "负债", 2: "所有者权益"},
  accessRules: ["发生额", "借方发生额", "贷方发生额", "余额", "期初余额", "借方余额", "贷方余额"],
  biAccessRules: [ "借方发生额", "贷方发生额", "余额", "借方余额", "贷方余额"],
  zcfzAccessRules: ["余额", "借方余额", "贷方余额", "末级借方余额", "末级贷方余额", "辅助核算借方余额", "辅助核算贷方余额"],
  xjllAccessRules: ["余额", "借方余额", "贷方余额", "期初余额", "发生额", "借方发生额", "贷方发生额"],
  lrAccessRules: ["发生额", "贷方发生额"],
  operation: {'+': " +", '-': "-"},
  reportTemplateItemSources: {0: "表外公式", 1: "表内公式"},
  vatRadios: {'SMALL_SCALE': "小规模纳税人", 'COMMONLY': "一般纳税人"},
  roles: {'Manager': "账套管理员", 'Director': "主管", 'Making': "制单人", 'Cashier': "出纳", 'View': "查看"},
  voucherTemplateType: {0: "日常支出", 1: "采购", 2: "销售", 3: "工资", 4: "税金", 5: "折旧和摊销"},
  industry: {
    "0": "批发、零售业",
    "1": "租赁和商务服务业",
    "2": "文化传媒/广告/设计",
    "3": "建筑业",
    "4": "住宿业",
    "5": "餐饮业",
    "6": "信息传输业",
    "7": "软件和信息技术服务业",
    "8": "房地产开发经营",
    "9": "物业管理",
    "10": "教育行业",
    "11": "医疗/医美/健康服务",
    "12": "电商/直播电商",
    "13": "人力资源/劳务派遣",
    "14": "居民服务/修理/美容美发",
    "15": "农、林、牧、渔业",
    "16": "工业",
    "17": "仓储业",
    "18": "邮政业",
    "19": "交通运输业",
    "20": "金融/投资/咨询（非银）",
    "21": "货物/技术进出口业",
    "22": "其他未列明行业"
  },
  industryMapping: {
    "0": {
      mainBusiness: "商品批量采购、渠道批发、仓储配送、品牌代理、大宗商品贸易、商品零售、门店销售、线上零售、售后维修",
      mainPurchase: "品牌商品、代理产品、大宗商品、库存商品、运输服务、仓储服务、零售商品、品牌货品、包装耗材、门店设备、线上平台服务",
      mainSales: "批发商品收入、零售商品收入、线上订单收入",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "1": {
      mainBusiness: "设备租赁、场地租赁、商务咨询、人力资源服务、会展服务、代理服务",
      mainPurchase: "租赁设备、场地资源、办公耗材、会展物料、人力外包服务、信息系统服务",
      mainSales: "设备租金收入、场地租赁费、商务咨询费、会展服务费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "2": {
      mainBusiness: "广告策划、品牌设计、影视制作、自媒体运营、活动执行、内容创作",
      mainPurchase: "设计软件、拍摄设备、场地租赁、创意策划费、媒体投放费、制作耗材",
      mainSales: "广告服务费、设计费、影视制作收入、自媒体广告收入、活动执行费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "3": {
      mainBusiness: "工程施工、建筑安装、装饰装修、工程总承包、项目管理、工程设计咨询",
      mainPurchase: "建筑材料（水泥/钢材/砂石）、工程设备、施工机械、劳务服务、周转材料、防水材料",
      mainSales: "建筑工程结算收入、安装工程收入、装饰装修收入、工程分包收入、设计咨询服务",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: true, hasImportExport: false
    },
    "4": {
      mainBusiness: "客房住宿服务、酒店管理、会务服务、住宿配套服务、客房清洁维护",
      mainPurchase: "客房布草、洗漱用品、床上用品、酒店设备、清洁耗材、餐饮食材（配套）",
      mainSales: "客房房费收入、会务服务费、配套服务收入、长租公寓收入、增值服务（洗衣/叫醒）",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "5": {
      mainBusiness: "餐饮服务、菜品制作、堂食/外卖服务、餐饮管理、宴会承办",
      mainPurchase: "食材原料、调味品、餐饮设备、餐具耗材、清洁用品、外卖平台服务",
      mainSales: "堂食收入、外卖订单收入、宴会承办收入、酒水饮料销售、餐饮配套服务",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "6": {
      mainBusiness: "通信网络运营、数据传输服务、宽带接入、通信工程维护、信息传输技术服务",
      mainPurchase: "通信设备、网络器材、服务器设备、光纤线缆、基站设施、技术维护服务",
      mainSales: "通信服务费、宽带接入费、数据传输费、设备租赁收入、技术维护服务收入",
      companyNature: "股份有限公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "7": {
      mainBusiness: "软件开发、系统集成、信息技术咨询、运维服务、软件定制、技术支持",
      mainPurchase: "服务器、云服务、开发工具、知识产权授权、办公设备、技术外包服务",
      mainSales: "定制化软件产品、SaaS服务、技术解决方案、信息化咨询服务、运维服务费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: true, hasConstruction: false, hasImportExport: false
    },
    "8": {
      mainBusiness: "房地产项目开发、商品房销售、土地开发、项目管理、配套设施建设",
      mainPurchase: "土地使用权、建筑工程服务、建材设备、设计服务、监理服务、融资服务",
      mainSales: "商品房销售收入、配套车位收入、商铺租金收入、项目转让收入、物业管理配套服务",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: true, hasImportExport: false
    },
    "9": {
      mainBusiness: "物业维护、安保服务、保洁服务、设施维修、业主服务、园区管理",
      mainPurchase: "保洁耗材、安保设备、维修材料、绿化工具、物业系统服务、水电能源",
      mainSales: "物业管理费、车位管理费、保洁服务费、维修服务费、园区配套服务收入",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "10": {
      mainBusiness: "学历教育、职业培训、艺术培训、语言培训、考试辅导、技能培训",
      mainPurchase: "教材教具、培训场地租赁、师资薪酬、教学设备、线上课程平台服务",
      mainSales: "学费收入、培训费收入、教材销售收入、课程服务费、考试辅导费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "11": {
      mainBusiness: "诊疗服务、医美整形、体检服务、康复护理、健康咨询、药品销售",
      mainPurchase: "药品、医疗器械、医美耗材、体检设备、医疗场地租赁、医护人员薪酬",
      mainSales: "诊疗收入、医美服务收入、体检收入、药品销售收入、健康咨询费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "12": {
      mainBusiness: "线上商品销售、直播带货、电商运营、供应链服务、平台入驻运营",
      mainPurchase: "库存商品、直播设备、平台服务费、主播薪酬、物流配送服务、营销推广费",
      mainSales: "商品销售收入、直播佣金收入、电商运营服务费、供应链服务费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "13": {
      mainBusiness: "劳务派遣、人事代理、招聘服务、社保代缴、薪酬代发、职业培训",
      mainPurchase: "招聘渠道费、培训服务费、办公场地租赁、人力资源管理系统服务",
      mainSales: "劳务派遣费、人事代理费、招聘服务费、人力资源服务费、薪酬代发服务费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "14": {
      mainBusiness: "美容美发、家电维修、汽车修理、家政服务、宠物服务、洗衣服务",
      mainPurchase: "美容耗材、维修配件、工具设备、清洁用品、宠物用品、场地租赁",
      mainSales: "美容美发收入、维修服务费、家政服务费、宠物服务费、洗衣服务费",
      companyNature: "个体工商户", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "15": {
      mainBusiness: "农作物种植、林木培育、畜禽饲养、水产养殖、农产品初加工、农林牧渔服务",
      mainPurchase: "种子种苗、化肥农药、饲料兽药、养殖设备、农机具、农用薄膜、鱼苗/种禽",
      mainSales: "粮食作物、经济作物、畜禽产品、水产品、林木产品、初加工农产品、养殖副产品",
      companyNature: "农民专业合作社", hasProduction: true, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "16": {
      mainBusiness: "产品制造、零部件加工、设备组装、工业生产、工艺改进、质量检测",
      mainPurchase: "原材料、辅助材料、生产设备、零部件、燃料动力、包装材料、劳保用品",
      mainSales: "产成品、半成品、加工服务、边角料、设备维修服务、定制化工业产品",
      companyNature: "有限责任公司", hasProduction: true, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "17": {
      mainBusiness: "货物仓储保管、仓库租赁、仓储管理、货物装卸、库存代管、冷链仓储",
      mainPurchase: "仓储设备、货架托盘、装卸机械、仓储耗材、冷链设备、仓库场地租赁",
      mainSales: "仓储保管费、仓库租赁费、装卸搬运费、库存管理费、冷链仓储服务费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "18": {
      mainBusiness: "邮政寄递服务、快递收发、邮政金融代理、报刊发行、物流配送服务",
      mainPurchase: "运输车辆、快递包装材料、分拣设备、燃油、网点场地租赁、信息系统服务",
      mainSales: "寄递服务收入、快递服务费、报刊发行收入、邮政代理服务费、物流配送收入",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "19": {
      mainBusiness: "道路货物运输、客运服务、物流配送、车辆调度、运输代理、货运代理",
      mainPurchase: "运输车辆、燃油/天然气、过路费、车辆维修保养、保险服务、运输设备配件",
      mainSales: "货物运输收入、客运服务收入、物流配送费、运输代理费、车辆租赁收入",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "20": {
      mainBusiness: "投资管理、财务咨询、金融顾问、资产管理、财富规划、信贷咨询",
      mainPurchase: "金融数据服务、咨询软件、办公场地租赁、专业人员薪酬、合规审计服务",
      mainSales: "投资收益、咨询服务费、财务顾问费、资产管理费、财富规划服务费",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    },
    "21": {
      mainBusiness: "货物进出口、技术进出口、代理进出口、跨境贸易、出口退税、报关报检、国际物流、保税仓储、外汇结算",
      mainPurchase: "进口商品、出口货源、国际物流服务、报关费、商检费、关税、外汇结算服务、技术授权",
      mainSales: "出口销售收入、进口销售收入、代理进出口服务费、技术转让收入、跨境物流费、出口退税收入",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: true
    },
    "22": {
      mainBusiness: "综合服务、专项技术服务、社区服务、便民服务、其他未分类经营活动",
      mainPurchase: "经营所需设备耗材、服务外包、场地租赁、办公耗材、相关配套服务",
      mainSales: "综合服务收入、专项服务费、便民服务收入、其他经营收入",
      companyNature: "有限责任公司", hasProduction: false, hasResearch: false, hasConstruction: false, hasImportExport: false
    }
  },
  assetsTemplateType: {
    '固定资产新增': '固定资产新增',
    '原值增加': '原值增加',
    '原值减少': '原值减少',
    '累计折旧变动': '累计折旧变动',
    '固定资产减少': '固定资产减少'
  },
});
